import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import TextAreaInputField from '../TextAreaInputField';
import s from './LimitedTextAreaInputField.scss';
/**
 * One of our standard, plaintext `<textarea />`s.
 *
 * Limits input to a a specified length (`max`) and displays the remaining character allowance in the bottom right of the input.
 */
var LimitedTextAreaInputField = React.forwardRef(function (_a, ref) {
    var _b;
    var maxLength = _a.maxLength, value = _a.value, className = _a.className, rest = __rest(_a, ["maxLength", "value", "className"]);
    return (React.createElement("div", { className: s['root'] },
        React.createElement(TextAreaInputField, __assign({ maxLength: maxLength, value: value, className: c(s['textarea'], className), ref: ref }, rest)),
        React.createElement("span", { className: s['remaining-length'] }, maxLength - ((_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0))));
});
LimitedTextAreaInputField.displayName = 'LimitedTextAreaInputField';
export default LimitedTextAreaInputField;
//# sourceMappingURL=LimitedTextAreaInputField.js.map